import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { RefreshScheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/auth/signin",
    "logout": "/",
    "home": "/",
    "callback": "/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "laravelPassport"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // laravelPassport
  $auth.registerStrategy('laravelPassport', new RefreshScheme($auth, {
  "name": "laravelPassport",
  "url": "https://api.emiratescort.com",
  "clientId": "3",
  "scope": "*",
  "grantType": "password",
  "token": {
    "property": "access_token",
    "type": "Bearer",
    "name": "Authorization",
    "maxAge": 31536000
  },
  "refreshToken": {
    "property": "refresh_token",
    "data": "refresh_token",
    "maxAge": 2592000
  },
  "user": {
    "property": false
  },
  "endpoints": {
    "token": "https://api.emiratescort.com/oauth/token",
    "login": {
      "baseURL": "",
      "url": "/_auth/laravelPassport/token"
    },
    "refresh": {
      "baseURL": "",
      "url": "/_auth/laravelPassport/token"
    },
    "logout": false,
    "user": {
      "url": "https://api.emiratescort.com/api/auth/user"
    }
  }
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
